import moment from "moment";

export const HHMMSSUTCToLocal = (value) => {
  let dx = new Date();
  let theDate = dx.getFullYear() + '-' + ( dx.getMonth() + 1 ) + '-' + dx.getDate();
  let theTime = theDate + " " + value;
  let newTime = new Date( Date.parse( theTime ) + 30*60*1000*11 );
  let h = newTime.getHours();
  let m = newTime.getMinutes();
  let s = newTime.getSeconds() === 0 ? "00" : newTime.getSeconds();
  return h + ":" + m + ":" + s;
};

export const HHMMSSLocalToUTC = (value) => {
  let dy = new Date();
  let theDate = dy.getFullYear() + '-' + ( dy.getMonth() + 1 ) + '-' + dy.getDate();
  let theTime = theDate + " " + value;
  let newTime = new Date( Date.parse( theTime ) - 30*60*1000*11 );
  let h = newTime.getHours();
  let m = newTime.getMinutes() === 0 ? "00" : newTime.getMinutes();
  let s = newTime.getSeconds() === 0 ? "00" : newTime.getSeconds();
  return h + ":" + m + ":" + s;
};

export const YYYYMMDDHHMMSSUTCToLocal = (value) => {
  let dx = new Date(value);
  let theDate = dx.getFullYear() + '-' + ( dx.getMonth() + 1 ) + '-' + dx.getDate();
  let theTime = theDate + " " + value;
  let newTime = new Date( Date.parse( theTime ) + 30*60*1000*11 );
  let ny = newTime.getFullYear();
  let nm = newTime.getMonth() + 1;
  let nd = newTime.getDate();
  let h = newTime.getHours();
  let m = newTime.getMinutes();
  let s = newTime.getSeconds() === 0 ? "00" : newTime.getSeconds();
  return ny + "-" + nm + "-" + nd + " " + h + ":" + m + ":" + s;
};

export const YYYYMMDDHHMMSSLocalToUTC = (value) => {
  let dx = new Date(value);
  let theDate = dx.getFullYear() + '-' + ( dx.getMonth() + 1 ) + '-' + dx.getDate();
  let theTime = theDate + " " + value;
  let newTime = new Date( Date.parse( theTime ) - 30*60*1000*11 );
  let ny = newTime.getFullYear();
  let nm = newTime.getMonth() + 1;
  let nd = newTime.getDate();
  let h = newTime.getHours();
  let m = newTime.getMinutes();
  let s = newTime.getSeconds() === 0 ? "00" : newTime.getSeconds();
  return ny + "-" + nm + "-" + nd + " " + h + ":" + m + ":" + s;
};


//-----------------------------------------
export const YYYYMMDDHHMMSSUTCToLocalDateTime = (value) => {
  let stillUtcStartDateSubEvent = moment.utc(value).toDate();
  let localStartDateSubEvent = moment(stillUtcStartDateSubEvent).local().format('YYYY-MM-DD HH:mm:ss');
  return localStartDateSubEvent;
};

export const YYYYMMDDHHMMSSLocalToUTCDateTime = (value) => {
  let stillUtcStartDateSubEvent = moment(value).utc().format("YYYY-MM-DD HH:mm:ss");
  return stillUtcStartDateSubEvent;
};
//-----------------------------------------


export const DateObjTOStringYYYYMMdd = (value, time) => {
  let newTime = value;
  let ny = newTime.getFullYear();
  let nm = (newTime.getMonth() + 1).toString().length===1?"0"+(newTime.getMonth() + 1):(newTime.getMonth() + 1);
  let nd = newTime.getDate().toString().length===1?"0"+newTime.getDate():newTime.getDate();
  let h = newTime.getHours().toString().length===1?"0"+newTime.getHours():newTime.getHours();
  let m = newTime.getMinutes().toString().length===1?"0"+newTime.getMinutes():newTime.getMinutes();
  let s = newTime.getSeconds().toString().length===1?"0"+newTime.getSeconds(): newTime.getSeconds();
  if(time) {
    return ny + "-" + nm + "-" + nd + " " + h + ":" + m + ":" + s;
  } else {
    return ny + "-" + nm + "-" + nd;
  }
};

export const convertDateObjStringToHumenReadable = (value) => {
  let split = value.split(".");
  let splitElement = split[0];
  let split1 = splitElement.split("T");
  let dataString = split1[0] + " " + split1[1];
  let theDate = new Date(dataString);;
  let newTime = new Date( Date.parse( theDate ) + 30*60*1000*11 );
  let ny = newTime.getFullYear();
  let nm = (newTime.getMonth() + 1).toString().length===1?"0"+(newTime.getMonth() + 1):(newTime.getMonth() + 1);
  let nd = newTime.getDate().toString().length===1?"0"+newTime.getDate():newTime.getDate();
  let h = newTime.getHours().toString().length===1?"0"+newTime.getHours():newTime.getHours();
  let m = newTime.getMinutes().toString().length===1?"0"+newTime.getMinutes():newTime.getMinutes();
  let s = newTime.getSeconds().toString().length===1?"0"+newTime.getSeconds(): newTime.getSeconds();
  return ny + "-" + nm + "-" + nd + " " + h + ":" + m + ":" + s;
};



export const d = [
  {
    date: "2020-02-28",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-01",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-02",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-04",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-05",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-06",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-07",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-08",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-09",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-10",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-11",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-12",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-13",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-14",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-15",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-16",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-17",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-18",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-19",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-20",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-21",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-22",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-23",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-24",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-25",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-26",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-27",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-28",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-29",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-30",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-03-31",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-04-01",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-04-02",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
  {
    date: "2020-04-03",
    totalSlotCount: 50,
    todaySlotBookedCount: 50,
    userReservation: [
      {
        name: 1,
        photoPath: "photo1",
        groupName: "group01",
        designation: "director",
        userReservationId: 1,
        slotNumber: 2
      }
    ]
  },
];
